/*required data for mapping elements into render*/
export const allItems = [
    {
    _id:'101', title: 'All Departments'
    },
    {
    _id:'102', title: 'Arts & Crafts'
    },
    {
    _id:'103', title: 'Automotive'
    },
    {
    _id:'104', title: ' Baby'
    },
    {
    _id:'105', title: 'Beauty & Personal Care'
    },
    {
    _id:'106', title: 'Books'
    },
    {
    _id:'107', title: 'Boys\' fashion'
    },
    {
    _id:'108', title: 'Computers'
    },
    {
    _id:'109', title: 'Deals'
    },
    {
    _id:'110', title: 'Digital Music'
    },
    {
    _id:'111', title: 'Electronics'
    },
    {
    _id:'112', title: 'Girls\' Fashion'
    },
    {
    _id:'113', title: 'Health & Household'
    },
    {
    _id:'114', title: 'Home & Kitchen'
    },
    {
    _id:'115', title: 'Industrial & Scientific'
    },
    {
    _id:'116', title: 'Kindle Store'
    },
    {
    _id:'117', title: 'Luggage'
    },
    {
    _id:'118', title: 'Men\'s Fashion'
    },
    {
    _id:'119', title: 'Movies & TV'
    },
    {
    _id:'120', title: 'Music. CDs & Vinyl'
    },
    {
    _id:'121', title: 'Pet Supplies'
    },
    {
    _id:'122', title: 'Prime Video'
    },
    {
    _id:'123', title: 'Software'
    },
    {
    _id:'124', title: 'Sports & Outdoors'
    },
    {
    _id:'125', title: 'Tools & Home Improvement'
    },
    {
    _id:'126', title: 'Toys & Games'
    },
    {
    _id:'127', title: 'Video Games'
    },
    {
    _id:'128', title: 'Women\'s Fashion'
    },
];

export const middleList = [
    {
        _id: 2221,
        title: 'Get to Know Us',
        listItem: [
            {
                _id: '001',
                listData: [
                    'Careers', 'Blog', 'About Amazon', 'Investor Relations', 'Amazon Devices', 'Amazon Science',
                ]
            }
        ]
    },
    {
        _id: 2222,
        title: 'Make Money with Us',
        listItem: [
            {
                _id: '002',
                listData: [
                    'Sell products on Amazon', 'Sell on Amazon Business', 'Sell apps on Amazon', 'Become an Affiliate', 'Advertise Your Products', 'Self-Publish with Us', 'Host an Amazon Hub', 'See More Make Money with Us',
                ]
            }
        ]
    },
    {
        _id: 2223,
        title: 'Amazon Payment Products',
        listItem: [
            {
                _id: '003',
                listData: [
                    'Amazon Business Card', 'Shop with Points', 'Reload Your Balance', 'Amazon Currency Converter',
                ]
            }
        ]
    },
    {
        _id: 2224,
        title: 'Let Us Help You',
        listItem: [
            {
                _id: '004',
                listData: [
                    'Amazon and COVID-19', 'Your Account', 'Your Orders', 'Shipping Rates & Policies', 'Returns & Replacements', 'Manage Your Content and Devices', 'Amazon Assistant', 'Help',
                ]
            }
        ]
    },
];

export const footerBottomItem = [
    {
        _id: 1001,
        title: 'Amazon Music',
        description: 'Stream millions of songs',
    },
    {
        _id: 1002,
        title: 'Amazon Advertising',
        description: 'Find, attract, and engage customers',
    },
    {
        _id: 1003,
        title: '6pm',
        description: 'Score deals on fashion brands',
    },
    {
        _id: 1004,
        title: 'AbeBooks',
        description: 'Books, art & collectibles',
    },
    {
        _id: 1005,
        title: 'ACX',
        description: 'Audiobook Publishing Made Easy',
    },
    {
        _id: 1006,
        title: 'Sell on Amazon',
        description: 'Start a Selling Account',
    },
    {
        _id: 1007,
        title: 'Amazon Business',
        description: 'Everything For Your Business',
    },
    {
        _id: 1008,
        title: 'AmazonGlobal',
        description: 'Ship Orders Internationally',
    },
    {
        _id: 1009,
        title: 'Home Services',
        description: 'Experienced Pros Happiness Guarantee',
    },
    {
        _id: 1010,
        title: 'Amazon Ignite',
        description: 'Sell your original Digital Educational Resources',
    },
    {
        _id: 1011,
        title: 'Amazon Web Services',
        description: 'Scalable Cloud Computing Services',
    },
    {
        _id: 1012,
        title: 'Audible',
        description: 'Listen to Books & Original Audio Performances',
    },
    {
        _id: 1013,
        title: 'Book Depository',
        description: 'Books With Free Delivery Worldwide',
    },
    {
        _id: 1014,
        title: 'Box Office Mojo',
        description: 'Find Movie Box Office Data',
    },
    {
        _id: 1015,
        title: 'ComiXology',
        description: 'Thousands of Digital Comics',
    },
    {
        _id: 1016,
        title: 'DPReview',
        description: 'Digital Photography',
    },
    {
        _id: 1017,
        title: 'Fabric',
        description: 'Sewing, Quilting & Knitting',
    },
    {
        _id: 1018,
        title: 'Goodreads',
        description: 'Book reviews & recommendations',
    },
    {
        _id: 1019,
        title: 'IMDb',
        description: 'Movies, TV & Celebrities',
    },
    {
        _id: 1020,
        title: 'IMDbPro',
        description: 'Get Info Entertainment Professionals Need',
    },
    {
        _id: 1021,
        title: 'Kindle Direct Publishing',
        description: 'Indie Digital & Print Publishing Made Easy',
    },
    {
        _id: 1022,
        title: 'Prime Video Direct',
        description: 'Video Distribution Made Easy',
    },
    {
        _id: 1023,
        title: 'Shopbop',
        description: 'Designer Fashion Brands',
    },
    {
        _id: 1024,
        title: 'Woot!',
        description: 'Deals and Shenanigans',
    },
    {
        _id: 1025,
        title: 'Zappos',
        description: 'Shoes & Clothing',
    },
    {
        _id: 1026,
        title: 'Ring',
        description: 'Smart Home Security Systems',
    },
    {
        _id: 1027,
        title: 'eero WiFi',
        description: 'Stream 4K Video in Every Room',
    },
    {
        _id: 1028,
        title: 'Blink',
        description: 'Smart Security for Every Home',
    },
    {
        _id: 1029,
        title: 'Neighbors App',
        description: 'Real-Time Crime & Safety Alerts',
    },
    {
        _id: 1030,
        title: 'Amazon Subscription Boxes',
        description: 'Top subsciption boxes - right to your door',
    },
    {
        _id: 1031,
        title: 'PillPack',
        description: 'Pharmacy Simplified',
    },
];